import { z } from 'zod/v4';

import { narrowWidgetPositionSchemaLegacy, visibilityPluginShapeLegacy } from '../../../common/schemas/legacy';

/**
 * One FAQ/accordion entry. `title`/`content` are rich-text HTML strings (edited in place via
 * `web-editor`, not through a settings sub-panel — this widget has none). `isOpen`/`contentHeight`
 * are declared and persisted, but only the PUBLISHED-site renderer
 * (`apps/websites-builder/.../widgets/accordion/accordion.component.ts`) reads/writes them as real
 * open/closed state; the editor's own view never trusts or persists them (its `dataAdapter` forces
 * `isOpen: false` on every load, and its expand/collapse toggle is pure DOM manipulation that never
 * touches the form). Modelled here anyway because the entity must round-trip what the builder needs.
 */
export const accordionItemSchemaLegacy = z.object({
    title: z.string(),
    content: z.string(),
    isOpen: z.boolean(),
    contentHeight: z.string(),
});

/**
 * Data shape for the `accordion` widget — the smallest settings surface of any migrated widget so
 * far: no animation, no shadow, no border/radius group at all. `horizontalAlign`/`iconType` mirror
 * the host's `EFaqIconPosition`/`EFaqIconStyle` string enums; `isSynchronizeStyle` is nullable
 * (button/indent precedent — very old widgets persist `null`, treated as `true`).
 */
export const accordionLegacyDataSchema = z.object({
    accordionList: z.array(accordionItemSchemaLegacy),
    horizontalAlign: z.enum(['L', 'R']),
    iconType: z.enum(['Caret', 'Plus']),
    isIndent: z.boolean(),
    themeIndentColor: z.string().nullable(),
    themeIconColor: z.string().nullable(),
    indentColor: z.string(),
    iconColor: z.string(),
    isAutoCollapse: z.boolean().nullish(),
    isSynchronizeStyle: z.boolean().nullable(),
    ...visibilityPluginShapeLegacy,
    position: narrowWidgetPositionSchemaLegacy.nullish(),
});
